// @flow
import React from 'react';
import {get} from 'lodash';
import AmenityCarousel from '../AmenityCarousel/AmenityCarousel';
import RecentlyViewedCarousel from '../RecentlyViewedCarousel/RecentlyViewedCarousel';
import FlexDatesCarousel from '../FlexDatesCarousel/FlexDatesCarousel';
import type {PropertyCardListingShape} from '../PropertyCarousel/PropertyCard/PropertyCard';
import type {Node} from 'react';
import {
    SERP_AMENITIES_CAROUSEL,
    SERP_PREVIOUSLY_VIEWED_CAROUSEL,
    SERP_FLEX_DATES_CAROUSEL
} from './utils/constants';

export type JudgeResultType = {
    component: string,
    level: string
};

type Props = {
    locale: string,
    isMobile: boolean,
    judgeResult: JudgeResultType[],
    placement: string,
    carouselPosition: string,
    hasPrevViewedListings: boolean,
    hasAmenityCarouselListings: boolean,
    hasFlexibleDatesListings: boolean,
    previouslyViewedListings: PropertyCardListingShape[],
    amenityCarouselData: PropertyCardListingShape[],
    flexibleDateListings: PropertyCardListingShape[],
    seeMoreUrl: string
};

const CarouselsContainer = ({
    locale,
    isMobile,
    judgeResult,
    placement,
    carouselPosition,
    hasPrevViewedListings,
    hasAmenityCarouselListings,
    hasFlexibleDatesListings,
    previouslyViewedListings,
    amenityCarouselData,
    flexibleDateListings,
    seeMoreUrl
}: Props): Node => {
    return judgeResult
        .filter(({level}) => level === placement)
        .map(({component}) => {
            if (
                component === SERP_PREVIOUSLY_VIEWED_CAROUSEL &&
                hasPrevViewedListings
            ) {
                return (
                    <section
                        className={`RecentlyViewedCarousel RecentlyViewedCarousel__${carouselPosition}`}
                    >
                        <RecentlyViewedCarousel
                            listings={previouslyViewedListings}
                            isMobile={isMobile}
                            position={carouselPosition}
                        />
                    </section>
                );
            }

            if (
                component === SERP_AMENITIES_CAROUSEL &&
                hasAmenityCarouselListings
            ) {
                return (
                    <AmenityCarousel
                        isMobile={isMobile}
                        seeMoreUrl={seeMoreUrl}
                        title={get(
                            amenityCarouselData,
                            `popularAmenitySearch.title`,
                            ''
                        )}
                        data={amenityCarouselData}
                        position={carouselPosition}
                    />
                );
            }

            if (
                component === SERP_FLEX_DATES_CAROUSEL &&
                hasFlexibleDatesListings
            ) {
                return (
                    <FlexDatesCarousel
                        isMobile={isMobile}
                        flexibleDateListings={flexibleDateListings}
                        locale={locale}
                        position={carouselPosition}
                    />
                );
            }

            return null;
        });
};

export default CarouselsContainer;
